import { createContext, useContext, useMemo } from "react"
import useOrganListener from "../hooks/useOrganListener";


// ------------  Context ---------------------------//
const OrganListenerContext = createContext();

// ------------  STATIC  ----------------------------------------------------------------------------- //



// ------------  Provider ---------------------------------------------------------------------------- //

export const OrganListenerContextProvider = ({children}) => {

  const {myProfileUpdated, myTeamData, myAccountData, myInvites} = useOrganListener();

  const memoizedValue = useMemo(()=> ({
    myAccountData,
    myTeamData,
    myProfileUpdated,
    myInvites
  }), [myAccountData, myTeamData, myProfileUpdated, myInvites]);

  return (<OrganListenerContext.Provider value={memoizedValue}>{children}</OrganListenerContext.Provider>)
}

export function useOrganListenerContext() {
  return useContext(OrganListenerContext);
}
